/**
 * Created by shaun on 16/09/2017.
 */

import Cookies from 'js-cookie';

import {
  ERROR,
  LOADING,
  LOGGED_OUT,
  SIGN_IN,
  SIGN_IN_TOKEN_REQUIRED,
  SIGNED_IN,
  EMPTY,
  READY,
  UPDATING
} from "module/constants";

import common from 'module/common';

import * as signInGoogle from './signIn/google';
import * as signInEmailToken from './signIn/emailToken';
import AuthorisationError from "../../../../../../resource/module/error/AuthorisationError";

const LOGIN_METHOD_GOOGLE = 'google';
const LOGIN_METHOD_EMAIL_TOKEN = 'emailToken';

const USER_TYPE_COOKIE = 'U_TYPE';

const ALL_LOGIN_METHODS = [LOGIN_METHOD_GOOGLE, LOGIN_METHOD_EMAIL_TOKEN];

const ADD_INITIALISED_LOGIN_METHOD = 'initialisedLoginMethod';

const LOGGED_IN_USER = 'loggedInUser';
const SELECTED_USER = 'selectedUser';
const ALL = 'all';

const SET_LOGGED_IN_STATE = 'loggedInState';
const SET_LOGGED_IN_STATE_REASON = 'loggedInStateReason';

const SET_SELECTED_STATE = 'selectedState';
const SET_SELECTED_STATE_REASON = 'selectedStateReason';

const SET_LOGGED_IN_USER = 'loggedInUser';
const SET_ALL_USERS = 'allUsers';
const SET_USER_TYPE = 'userType';
const SET_ALL_LIMITATIONS = 'allLimitations'

const SET_ALL_BRANCH_STAKEHOLDERS = 'branchStakeholders'

const SET_USERS_AS_OBJECT = 'setUsersAsObject';


const RESET_LOGGED_IN_USER = 'resetLoggedInUser';

// initial state
const state = {
  allLimitations: [],
  branchStakeholders:[],
  [LOGGED_IN_USER]: {
    state: {
      state: EMPTY,
      previous: null,
      reason: null,
      userType: null,
    },
    user: {
      name: null,
      email: null,
      avatar: null,
      groups: [],
      limitations: [],
      settings: {},
    },
    initialisedLoginMethods: []
  },
  [SELECTED_USER]: {
    state: {
      state: EMPTY,
      previous: null,
      reason: null,
    },
    user: {
      name: null,
      email: null,
      avatar: null,
      groups: [],
      limitations: [],
      settings: {},
    }
  },
  [ALL]: {
    state: {
      state: EMPTY,
      previous: null,
      reason: null,
    },
    users: {
      all: [],
      allExternal: [],
      byWorkflow: null,
      userByObj: null
    }
  }
};

//actions
const actions = {
  ...signInGoogle.actions,
  ...signInEmailToken.actions,
  initLoginMethods({dispatch, commit, getters, rootGetters}, loginMethod) {
    if (Cookies.get('yqnPETCANgPUvv7cLYfHWgLjh4A8tF79') && loginMethod !== LOGIN_METHOD_GOOGLE) {
      dispatch('initLoginMethod', LOGIN_METHOD_EMAIL_TOKEN);
    } else {
      commit(SET_LOGGED_IN_STATE, SIGN_IN);
    }
  },
  verifyLogin({commit, dispatch}, user) {
    commit(SET_LOGGED_IN_STATE, LOADING);
    common
      .httpPost('verify')
      .data({})
      .then((res) => {
        commit(SET_LOGGED_IN_STATE, SIGNED_IN);
        commit(SET_LOGGED_IN_USER, res.data.loggedInUser);

        dispatch('brand/load', null, {root: true});
      }, (error) => {
        if (error instanceof AuthorisationError && error.data.code === 401) {
          //user is not logged in
          commit(SET_LOGGED_IN_STATE, SIGN_IN);
          dispatch('initAllLoginMethods');
        } else {
          //some other error
          commit(SET_LOGGED_IN_STATE, ERROR);
          dispatch('initAllLoginMethods');
        }
      });
  },
  initAllLoginMethods({dispatch}) {
    ALL_LOGIN_METHODS.forEach((loginMethod) => {
      dispatch('initLoginMethod', loginMethod);
    });
  },
  initLoginMethod({state, dispatch, commit}, loginMethod) {
    if (state[LOGGED_IN_USER].initialisedLoginMethods.indexOf(loginMethod) <= -1) {
      commit(ADD_INITIALISED_LOGIN_METHOD, loginMethod);
      dispatch('init' + _.upperFirst(loginMethod));
    }
  },
  initAllUsers({commit, getters, dispatch, rootGetters}, filter) {
    common
      .httpGet('user')
      .idToken(getters['idToken']())
      .query({get: 'userList', filter: filter})
      .then((res) => {
        commit(SET_ALL_USERS, res.data.all);
      }, ({data}) => {
        dispatch('error/error', data, {root: true});
      });
  },
  initAllLimitations({commit, getters, dispatch}) {
    common
      .httpGet('user')
      .idToken(getters['idToken']())
      .query({get: 'limitationOptions'})
      .then((res) => {
        commit(SET_ALL_LIMITATIONS, res.data);
      }, ({data}) => {
        dispatch('error/error', data, {root: true});
      });
  },
  initAllBranchStakeholders({commit, getters, dispatch}) {
    common
      .httpGet('user')
      .idToken(getters['idToken']())
      .query({get: 'BranchShareholdersOptions'})
      .then((res) => {
        commit(SET_ALL_BRANCH_STAKEHOLDERS, res.data);
      }, ({data}) => {
        dispatch('error/error', data, {root: true});
      });
  },
  resetLoginState({commit}) {
    commit(SET_LOGGED_IN_STATE, SIGN_IN);
  },
  logoutUser({dispatch, commit}) {
    commit(SET_LOGGED_IN_STATE, LOGGED_OUT);
    dispatch('signOut');
  },
  addTimeOff({dispatch}, {user, date, amOrPm, reason}) {
    return dispatch('save', {
      user,
      label: 'Add Time Off',
      data: {
        timeOff: 'add',
        date,
        amOrPm,
        reason
      }
    });
  },
  updateUserRecord({ commit, dispatch }, { user, selectedUser, selectedEmail, selectedTelephone, currentEmail, selectedState, starkId, selectedUserLimitations,selectedBranchDetails }) {
    console.log('inside updateUserRecord: ', selectedBranchDetails)
    return dispatch('save', {
      user,
      label: 'update user record',
      data: {
        manage: 'updateUserRecord',
        selectedUser: selectedUser,
        selectedUserLimitations: selectedUserLimitations,
        starkId: starkId,
        selectedEmail: selectedEmail,
        selectedTelephone: selectedTelephone,
        currentEmail: currentEmail,
        selectedState :selectedState,
        selectedBranchDetails: selectedBranchDetails,
      }
    }).then((updatedUsers) => {
      commit(SET_ALL_USERS, updatedUsers.data.all);
    });
  },
  updateBulkUserRecord({ commit, dispatch }, { user, selectedBulkUsersArray,selectedStateForBulkUsers }) {
    return dispatch('save', {
      user,
      label: 'update bulk user records',
      data: {
        manage: 'updateBulkUserRecord',
        selectedBulkUsersArray: selectedBulkUsersArray,
        selectedStateForBulkUsers: selectedStateForBulkUsers,
      }
    }).then((updatedUsers) => {
      commit(SET_ALL_USERS, updatedUsers.data.all);
    });
  },
  removeTimeOff({dispatch}, {user, timeOff}) {
    return dispatch('save', {
      user,
      label: 'Remove Time Off',
      data: {
        timeOff: 'remove',
        timeOffKey: _.get(timeOff, 'key', null)
      }
    });
  },
  createLoginForCompanyContact({dispatch, commit}, {user, company, contact, email}) {
    return dispatch('save', {
      user,
      label: 'Create Contact Login',
      data: {
        manage: 'createLoginForCompanyContact',
        company: company,
        contact: contact,
        email: email
      }
    }).then((res) => {
      commit(SET_ALL_USERS, res.data.all);
    }, () => {

    });
  },
  sendWelcomeEmailForCompanyContact({dispatch, commit}, {user, company, contact}) {
    return dispatch('save', {
      user,
      label: 'Send Welcome Email',
      data: {
        manage: 'sendWelcomeEmailForCompanyContact',
        company: company,
        contact: contact
      }
    }).then((res) => {
      commit(SET_ALL_USERS, res.data.all);
    }, () => {

    });
  },
  disableLoginForCompanyContact({dispatch, commit}, {user, company, contact}) {
    return dispatch('save', {
      user,
      label: 'Disable Contact Login',
      data: {
        manage: 'disableLoginForCompanyContact',
        company: company,
        contact: contact
      }
    }).then((res) => {
      commit(SET_ALL_USERS, res.data.all);
    }, () => {

    });
  },
  saveEventNotificationPreferences({dispatch, commit}, {user, contact, company, events, entity}) {
    return dispatch('save', {
      user,
      label: 'Save Notification Preferences',
      data: {
        user: 'saveEventNotificationPreferences',
        company: company,
        contact: contact
      }
    }).then((res) => {
      commit(SET_ALL_USERS, res.data.all);
    }, () => {

    });
  },
  tempSet({commit, dispatch}, {key, value}) {
    return dispatch('save', {
      label: 'Temp Set',
      data: {
        user: 'tempSet',
        key,
        value,
      }
    });
  },
  signOut({commit, dispatch}, ignoreGoogle = false) {
    common
      .httpPost('user')
      .recaptchaAction('signOutEmailUser')
      .data({login: 'signOutEmailUser'})
      .then(() => {
        if (!ignoreGoogle) {
          dispatch('logoutUserWithGoogle');
        }

        commit(SET_LOGGED_IN_STATE, SIGN_IN);
        commit(SET_LOGGED_IN_USER, null);
      }, ({response}) => {
        commit(SET_LOGGED_IN_STATE, ERROR);
        if (response && response.body && response.body.message) {
          commit(SET_LOGGED_IN_STATE_REASON, response.body.message);
        }
      });
  },
  save({commit, dispatch, state, getters}, {user, label, action, data}) {
    data = _.merge({
      userId: user ? user._id : null,
      idToken: getters['idToken'](),
      action
    }, data);

    if (state[SELECTED_USER].state === READY !== null && state[SELECTED_USER].user._id && user._id) {
      commit(SET_SELECTED_STATE, UPDATING);
    }

    return new Promise((resolve, reject) => {
      common
        .httpPost('user')
        .data(data)
        .then((res) => {
          if (state[SELECTED_USER].user._id && user._id) {
            commit(SET_SELECTED_STATE, UPDATING);
          }
          resolve(res);
        }, (error) => {
          dispatch('error/error', error, {root: true});
          reject(error);
        });
    });
  }
};

//getters
const getters = {
  ...signInGoogle.getters,
  ...signInEmailToken.getters,
  primaryWorkflow(state) {
    return state[LOGGED_IN_USER].user.limitations
      .filter(limitation => limitation.limit === 'WORKFLOW')
      .map((workflow) => {
        return {
          value: workflow.value,
          label: _.startCase(workflow.value.split('_')[1])
        }
      })
      .slice(0, 1)[0] || null;
  },
  secondaryWorkflows(state) {
    return state[LOGGED_IN_USER].user.limitations
      .filter(limitation => limitation.limit === 'WORKFLOW')
      .map((workflow) => {
        return {
          value: workflow.value,
          label: _.startCase(workflow.value.split('_')[1])
        }
      })
      .slice(1)
  },
  type(state) {
    return state.userType;
  },
  userWorkflows(state) {
    const disallowedMenuLabels = [' Project Follow Up', 'Quote For Materials', 'Order Follow Up'];

    return state[LOGGED_IN_USER].user.limitations
      .filter(limitation => limitation.limit === 'WORKFLOW')
      .map((workflow) => {
        const label = _.startCase(workflow.value.split('_')[1]);
        if (!disallowedMenuLabels.includes(label)) {
          return {
            value: workflow.value,
            label: label
          };
        }
        return null;
      })
      .filter(workflow => workflow !== null);
  },
  canManageWorkflow(state, getters) {
    return (entity, workflowToCheck) => {
      entity = entity === 'quote' ? 'project' : entity;
      return getters.userWorkflows.filter(workflow => workflow.value === `${entity}_${workflowToCheck}`).length >= 1
    }
  },
  hasGroupOrStakeholder(state, getters) {
    return (value) => {
      return getters.hasGroup(value) || getters.hasStakeholder(value);
    }
  },
  hasGroup(state) {
    return (group) => {
      return state[LOGGED_IN_USER].user.groups.filter((groupToCheck) => {
        return groupToCheck === group;
      }).length >= 1;
    }
  },
  hasStakeholder(state) {
    return (stakeholder) => {
      return state[LOGGED_IN_USER].user.limitations.filter(({limit, value}) => {
        return limit === 'STAKEHOLDER' && value === stakeholder;
      }).length >= 1;
    }
  },
  hasLimitation(state, getters) {
    return (limitation) => {
      return getters.limitationValues(limitation).length >= 1;
    }
  },
  limitationValues(state) {
    return (limitation) => {
      return state[LOGGED_IN_USER].user.limitations
        .filter(({limit}) => {
          return limit === limitation;
        })
        .map(limit => limit.value);
    }
  },
  isLimitationValue(state) {
    return (limitation, expectedValue) => {
      return state[LOGGED_IN_USER].user.limitations.filter(({limit, value}) => {
        return limit === limitation && value === expectedValue;
      }).length >= 1;
    }
  },
  roles(state) {
    return state[LOGGED_IN_USER].user.limitations.reduce((roles, {name, value}) => {
      roles.backOffice = name === 'BACK_OFFICE' && value === true;
      roles.manageTasks = name === 'MANAGE_TASKS' && value === true;
      roles.manageOwnTasks = name === 'MANAGE_OWN_TASKS' && value === true;
      return roles;
    }, {});
  },
  loggedInUser() {
    return state[LOGGED_IN_USER].user;
  },
  isDev(state, getters) {
    return getters.hasLimitation('VIEW_TEST_QUOTES');
  },
  isInternal(state) {
    return state[LOGGED_IN_USER].user.email.includes('@buildaviator.services') || state[LOGGED_IN_USER].user.email.includes('@projectestimator.services');
  },
  isExternalCompany(state, getters) {
    return getters.hasLimitation('EXTERNAL_COMPANY');
  },
  allExternal(state) {
    return state.all.users.allExternal ?? [];
  },
  name(state) {
    return state[LOGGED_IN_USER].user.name ?? 'Unknown';
  },

  getAllLimitations(){
    return state.allLimitations ?? [];
  },
  getBranchStakeholdersOptions(){
    return state.branchStakeholders ?? [];
  },
  userInformationAsObject(state){
    return state.all.users.internalUsers;
  }
};

// mutations
const mutations = {
  [SET_LOGGED_IN_STATE](state, newState) {
    state[LOGGED_IN_USER].state.previous = state[LOGGED_IN_USER].state.state;
    state[LOGGED_IN_USER].state.state = newState;
  },
  [SET_LOGGED_IN_STATE_REASON](state, stateReason) {
    state[LOGGED_IN_USER].state.reason = stateReason;
  },
  [ADD_INITIALISED_LOGIN_METHOD](state, loginMethod) {
    state[LOGGED_IN_USER].initialisedLoginMethods.push(loginMethod);
  },
  [SET_LOGGED_IN_USER](state, user) {
    if (window.location.pathname.indexOf('/portal') === 0 && _.get(user, 'settings.migrationTarget') === true) {
      setTimeout(() => {
        window.location.href = '/beta#/list/both/myProjects-currentTasks'
      }, parseInt(_.random(25, 61) + '000'))
    }

    state[LOGGED_IN_USER].user = user;
  },
  [RESET_LOGGED_IN_USER](state, user) {
    state[LOGGED_IN_USER].user = {
      state: {
        state: EMPTY,
        previous: null,
        reason: null,
      },
      user: {
        name: null,
        email: null,
        avatar: null,
        groups: [],
        limitations: [],
        settings: {},
      },
      initialisedLoginMethods: []
    };
  },
  [SET_SELECTED_STATE](state, newState) {
    state[SELECTED_USER].state.previous = state[SELECTED_USER].state.state;
    state[SELECTED_USER].state.state = newState;
  },
  [SET_SELECTED_STATE_REASON](state, stateReason) {
    state[SELECTED_USER].state.reason = stateReason;
  },
  [SET_ALL_USERS](state, allUsers) {
    state.all.users = allUsers;
  },
  [SET_USER_TYPE](state, userType) {
    state.userType = userType;
  },
  [SET_USERS_AS_OBJECT](state, usersObj) {
    state.all.users.userAsObj = { ...usersObj };
  },
  [SET_ALL_LIMITATIONS](state, limitation) {
    state.allLimitations = limitation;
  },
  [SET_ALL_BRANCH_STAKEHOLDERS](state, limitation) {
    state.branchStakeholders = limitation;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}